
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Borivalitopunecab() {



    const cardData =
    {
        keyword: 'Borivali to Pune Cab',
        heading: 'Meghana Cab : Borivali to Pune Cab',
        headingDescription: 'Meghana Cab offers Borivali to Pune Cab services, delivering a reliable and comfortable travel experience from Mumbai’s western suburb to the cultural hub of Pune. Whether you are planning a business trip, family outing, or personal travel, our clean, air-conditioned cabs and trained drivers ensure a safe and timely journey. Choose from hatchbacks, sedans, SUVs, or tempo travellers depending on your group size and preferences. With transparent fares, doorstep pickup, and 24/7 customer support, Meghana Cab makes intercity travel convenient and stress-free. Book your Borivali to Pune Cab with Meghana Cab for a smooth, secure, and pleasant ride every time.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
   {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 by Sultan Aga Khan III to provide famine relief, this elegant Italian‑arched palace later became the site of Mahatma Gandhi’s imprisonment. Surrounded by expansive lawns, the palace now houses a Gandhi museum and memorials to Kasturba and Mahadev Desai, preserving the legacy of India’s freedom struggle." 
  },
    {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, this grand fortification features massive teak doors, strong granite ramparts, ornate gardens, and historic ruins. Though largely destroyed by fire in 1828, its five gateways—including the north‑facing Delhi Darwaza—and remaining bastions offer a poignant glimpse into Maratha royal ambition and architectural finesse." 
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched about 1,312 m above sea level on the Sahyadri range, this hill‑top fortress was the scene of the legendary 1670 Battle of Sinhagad. It boasts steep slopes, two main gates (Pune and Kalyan Darwaza), the memorial to warrior Tanaji Malusare, and offers sweeping views and popular local cafés at dawn." 
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in Koregaon Park, this serene meditation centre was founded on Osho’s teachings. It features lush gardens, modern meditation halls, and a range of wellness workshops, attracting seekers from across the globe seeking peace and self‑discovery." 
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th‑century rock‑cut temple carved out of a single basalt block, this underground temple honors Lord Shiva and includes a majestic Nandi shrine within a circular mandapa supported by pillars—an ancient gem offering spiritual calm amidst the city." 
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most revered Ganesha shrines, known for its beautifully adorned gold idol. The temple buzzes during festivals, drawing thousands of pilgrims and visitors seeking blessings and experiencing vibrant Marathi devotion." 
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Rising to 2,100 ft, Parvati Hill is the city’s second‑highest point and hosts the historic Peshwa‑era Parvati Temple atop its summit. The climb (108 steps) rewards visitors with panoramic views of Pune’s sprawl and the surrounding Western Ghats." 
  },
  {
    "title": "Lal Mahal",
    "description": "This ‘Red Palace’—originally built by Shivaji’s father—played a key role in Maratha history. Though largely reconstructed, its red‑plastered walls stand as a landmark in Old Pune and a reminder of the era’s parentage and heritage." 
  },
  {
    "title": "Shinde Chhatri",
    "description": "A memorial shrine dedicated to Maratha commander‑in‑chief Mahadji Shinde (Scindia), this elegant domed pavilion built in 1794 showcases exquisite carvings and Rajasthani‑style architectural influences—a peaceful heritage spot near Wanwadi." 
  },
  {
    "title": "Rajiv Gandhi Zoological Park",
    "description": "Also known as Katraj Zoo & Snake Park, this well‑maintained park on the city’s outskirts is home to diverse wildlife, reptiles, aviaries, botanical collections, and an urbane, family‑friendly educational experience." 
  }
],

"services": [
  {
    "name": "Borivali to Pune Taxi Booking",
    "description": "Secure your taxi from Borivali to Pune with our easy and reliable booking service. Enjoy timely pickups, clean vehicles, and professional drivers who prioritize your comfort and safety throughout the journey."
  },
  {
    "name": "One Way Cab from Borivali to Pune",
    "description": "Travel hassle-free with our one-way cab service from Borivali to Pune. Perfect for quick trips, our cabs provide punctual pickups, comfortable seating, and experienced drivers for a smooth ride."
  },
  {
    "name": "Round Trip Borivali to Pune Taxi",
    "description": "Plan your round trip between Borivali and Pune with our flexible taxi service. Benefit from well-maintained cars, courteous drivers, and affordable packages designed to fit your schedule and travel needs."
  },
  {
    "name": "Borivali West to Pune Cab",
    "description": "Reliable cab services from Borivali West to Pune, offering efficient and safe transportation. Our drivers know the best routes to ensure timely arrivals, making your travel stress-free."
  },
  {
    "name": "Affordable SUV Borivali to Pune",
    "description": "Enjoy spacious and comfortable SUV rides from Borivali to Pune at budget-friendly rates. Ideal for families and groups who need extra space without compromising on comfort or safety."
  },
  {
    "name": "AC Sedan Hire Borivali to Pune",
    "description": "Experience luxury and comfort with our air-conditioned sedan hire service from Borivali to Pune. Perfect for business travelers and small families seeking a smooth and cool journey."
  },
  {
    "name": "Online Cab Borivali to Pune",
    "description": "Book your Borivali to Pune cab conveniently online. Our user-friendly platform allows quick vehicle selection, instant confirmation, and hassle-free payment options for a seamless travel experience."
  },
  {
    "name": "Borivali East to Pune Car Rental",
    "description": "Get reliable car rental services from Borivali East to Pune. Whether it’s a short trip or a long journey, our well-maintained cars and experienced drivers ensure your ride is safe and comfortable."
  },
  {
    "name": "Budget Cabs Borivali to Pune",
    "description": "Affordable and trustworthy budget cab options from Borivali to Pune. Enjoy safe travel with clean vehicles and professional drivers while keeping your costs low."
  },
  {
    "name": "Private Taxi Borivali to Pune",
    "description": "Hire a private taxi from Borivali to Pune for a personalized travel experience. Perfect for those who value privacy, flexible schedules, and comfort on their journey."
  },
  {
    "name": "Long Route Travel Cab Borivali to Pune",
    "description": "Take advantage of our long-route travel cabs from Borivali to Pune, designed for extended trips with comfortable seating and knowledgeable drivers who make the journey pleasant and relaxing."
  },
  {
    "name": "Borivali to Pune Ride with Driver",
    "description": "Enjoy a stress-free ride from Borivali to Pune with our professional drivers who ensure safety, punctuality, and courteous service throughout your journey."
  },
  {
    "name": "Chauffeur Service Borivali to Pune",
    "description": "Travel in style and luxury with our chauffeur-driven service from Borivali to Pune. Our well-trained chauffeurs provide a premium experience, perfect for corporate or special occasions."
  },
  {
    "name": "Expressway Cabs Borivali to Pune",
    "description": "Save time and enjoy a smooth drive on the expressway with our dedicated cab service from Borivali to Pune. Our drivers use the fastest routes while maintaining your comfort and safety."
  },
  {
    "name": "24-Hour Cab Booking Borivali to Pune",
    "description": "Book your Borivali to Pune taxi anytime with our 24-hour service. Whether day or night, expect prompt responses, quick pickups, and reliable rides whenever you need them."
  }
],
"tableData": [
  ["Borivali to Pune Taxi Booking", "One Way Cab from Borivali to Pune"],
  ["Round Trip Borivali to Pune Taxi", "Borivali West to Pune Cab"],
  ["Affordable SUV Borivali to Pune", "AC Sedan Hire Borivali to Pune"],
  ["Online Cab Borivali to Pune", "Borivali East to Pune Car Rental"],
  ["Budget Cabs Borivali to Pune", "Private Taxi Borivali to Pune"],
  ["Long Route Travel Cab Borivali to Pune", "Borivali to Pune Ride with Driver"],
  ["Chauffeur Service Borivali to Pune", "Expressway Cabs Borivali to Pune"],
  ["24-Hour Cab Booking Borivali to Pune", ""]
],








"whychoose": [
    {
        "WhyChooseheading": "Dependable Borivali to Pune Cab Service",
        "WhyChoosedescription": "Meghana Cab provides reliable cab services from Borivali to Pune, ensuring a safe and comfortable journey for all travelers. Experience smooth rides with our well-maintained fleet and professional drivers."
    },
    {
        "WhyChooseheading": "Comprehensive Travel Packages from Borivali to Pune",
        "WhyChoosedescription": "Whether you need a one-way trip or round-trip package, we customize cab services to fit your schedule and preferences. Perfect for leisure travelers, business trips, and family outings."
    },
    {
        "WhyChooseheading": "Transparent Fare Structure with No Hidden Fees",
        "WhyChoosedescription": "Our Borivali to Pune cab fares include all costs such as fuel, tolls, driver allowance, and taxes. We offer clear pricing upfront with no surprises, allowing you to choose from multiple vehicle options."
    },
    {
        "WhyChooseheading": "Comfortable and Hygienic Vehicles for Long Distance Travel",
        "WhyChoosedescription": "Travel comfortably in sanitized, air-conditioned sedans, SUVs, or tempo travellers. Our vehicles are regularly cleaned and serviced to ensure a pleasant journey over the approximately 150 km distance."
    },
    {
        "WhyChooseheading": "Experienced Drivers Knowledgeable of the Route",
        "WhyChoosedescription": "Our drivers are familiar with the fastest routes and traffic patterns from Borivali to Pune, ensuring timely pickups and drop-offs while maintaining safety and comfort."
    },
    {
        "WhyChooseheading": "Flexible Scheduling and Customized Travel Plans",
        "WhyChoosedescription": "Choose from flexible booking options including one-way rides, round-trips, and multi-day packages. Customize your trip with stops or overnight stays as per your convenience."
    },
    {
        "WhyChooseheading": "24/7 Booking Assistance and Customer Support",
        "WhyChoosedescription": "Book your Borivali to Pune cab anytime with our 24/7 support team ready to assist. We provide real-time updates and help throughout your journey to ensure a hassle-free experience."
    },
    {
        "WhyChooseheading": "Ideal for Families, Business Travelers, and Groups",
        "WhyChoosedescription": "Our cab services cater to all types of travelers including families, corporate clients, and group tours. We focus on comfort, punctuality, and safety to make your trip memorable."
    }
]























    }

const faqData = [
    {
        question: "How can I book a cab from Borivali to Pune with Meghana Cab?",
        answer: "You can book your Borivali to Pune cab by calling Meghana Cab at +91 9075462128 or via our website for fast and easy booking."
    },
    {
        question: "What vehicle options are available for the Borivali to Pune route?",
        answer: "We offer sedans, SUVs, and tempo travellers suitable for solo travelers, families, and groups."
    },
    {
        question: "Are Meghana Cab drivers familiar with the Borivali to Pune route?",
        answer: "Yes, our drivers are well-acquainted with the route and ensure a safe, smooth journey."
    },
    {
        question: "Can I book a one-way cab from Borivali to Pune?",
        answer: "Yes, both one-way and round-trip cab services are available."
    },
    {
        question: "Does the fare cover tolls, fuel, and driver charges?",
        answer: "Our fare includes fuel, tolls, and driver charges. Additional fees may apply for parking or waiting time."
    },
    {
        question: "Are the vehicles sanitized before trips?",
        answer: "Absolutely, all vehicles are thoroughly sanitized before each journey."
    },
    {
        question: "Is the Borivali to Pune cab service available 24/7?",
        answer: "Yes, we offer round-the-clock service to suit your travel plans."
    },
    {
        question: "Can I request stops for meals or sightseeing during the trip?",
        answer: "Yes, halts can be arranged upon request; please notify us during booking."
    },
    {
        question: "What payment methods are accepted?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How do I contact Meghana Cab to book a Borivali to Pune cab?",
        answer: "Call us anytime at +91 9075462128 to book your ride or get assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sameer Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided a comfortable and punctual ride from Borivali to Pune. Highly recommended!”',
    },
    {
        name: 'Mrs. Neha Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great experience with Meghana Cab for our Borivali to Pune trip. The driver was courteous and the vehicle clean.”',
    },
];








































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const borivaliToPuneCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Borivali to Pune Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/borivali-to-pune-cab.jpg",
  "description": "Book affordable and reliable taxi service from Borivali to Pune with Meghana Cabs. One way and round trip cabs available with AC sedans and SUVs.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "Borivali to Pune Taxi Booking",
    "One Way Cab from Borivali to Pune",
    "Round Trip Borivali to Pune Taxi",
    "Borivali West to Pune Cab",
    "Affordable SUV Borivali to Pune",
    "AC Sedan Hire Borivali to Pune",
    "Online Cab Borivali to Pune",
    "Borivali East to Pune Car Rental",
    "Budget Cabs Borivali to Pune",
    "Private Taxi Borivali to Pune",
    "Long Route Travel Cab Borivali to Pune",
    "Borivali to Pune Ride with Driver",
    "Chauffeur Service Borivali to Pune",
    "Expressway Cabs Borivali to Pune",
    "24-Hour Cab Booking Borivali to Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Borivali"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Borivali to Pune Taxi Offers",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Cab from Borivali to Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Borivali to Pune Taxi"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "AC Sedan Hire Borivali to Pune"
        }
      }
    ]
  }
};






    return (
        <div>

<Helmet>
  <title>Borivali to Pune Cab | Affordable Taxi Service</title>
  <meta
    name="description"
    content="Book affordable and reliable taxi service from Borivali to Pune with Meghana Cabs. One way and round trip cabs available with AC sedans and SUVs."
  />
  <meta
    name="keywords"
    content="Borivali to Pune Taxi Booking, One Way Cab from Borivali to Pune, Round Trip Borivali to Pune Taxi, Borivali West to Pune Cab, Affordable SUV Borivali to Pune, AC Sedan Hire Borivali to Pune, Online Cab Borivali to Pune, Borivali East to Pune Car Rental, Budget Cabs Borivali to Pune, Private Taxi Borivali to Pune, Long Route Travel Cab Borivali to Pune, Borivali to Pune Ride with Driver, Chauffeur Service Borivali to Pune, Expressway Cabs Borivali to Pune, 24-Hour Cab Booking Borivali to Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(borivaliToPuneCabSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/46.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Borivalitopunecab;